import { z } from 'zod';

import {
  parseToolResultMetadata,
  type ToolResultMetadata,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/toolResultMetadata';
import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';

const ToolResultMutatedContentSchema = z.object({
  mutated: z.literal(true),
});

/** Backend copies `mutated: true` onto toolResult JSON content when a mayMutate tool finishes. */
const readWorkspaceAgentToolResultMutatedFromContent = (content: string | null): boolean => {
  if (!content) {
    return false;
  }

  try {
    const parsed = JSON.parse(content);

    return ToolResultMutatedContentSchema.safeParse(parsed).success;
  } catch {
    return false;
  }
};

const workspaceAgentToolResultMutatedWorkspace = (metadata: ToolResultMetadata, content: string | null): boolean =>
  metadata.mutated === true || readWorkspaceAgentToolResultMutatedFromContent(content);

/**
 * True when backend `mutated: true` is present on toolResult metadata and/or JSON content
 * (WSS live rows and REST catch-up when the server adds `mutated` after persistence).
 */
export const workspaceAgentMessageShouldInvalidateCaches = (message: WorkspaceAgentMessage): boolean => {
  if (message.role !== 'toolResult') {
    return false;
  }

  const parsed = parseToolResultMetadata(message.metadata);

  if (parsed?.outcome === 'readable') {
    return workspaceAgentToolResultMutatedWorkspace(parsed.metadata, message.content);
  }

  return readWorkspaceAgentToolResultMutatedFromContent(message.content);
};
